import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class FormsPreviewService {

    constructor(
        private http: HttpClient
    ) { }

    getForm(id) {
        return this.http.get(environment.serverUrl + '/taskTemplate/' + id);
    }

    publish(taskTemplateId) {
        const body = {
            formTemplateId: taskTemplateId,
            category: 'inspection'
        };
        return this.http.put(environment.serverUrl + '/publishTaskTemplate', body);
    }

    updateTag(tag, taskTemplateId) {
        const body = {
            formTemplateId: taskTemplateId,
            tag: tag
        };
        return this.http.put(environment.serverUrl + '/taskTemplate/updateTag', body);
    }

    deactivate(taskTemplateId) {
        const body = {
            formTemplateId: taskTemplateId
        };
        return this.http.put(environment.serverUrl + '/taskTemplate/deactivate', body);
    }

    archive(taskTemplateId) {
        const body = {
            formTemplateId: taskTemplateId
        };
        return this.http.put(environment.serverUrl + '/taskTemplate/archive', body);
    }

    formpreview(id){
        return this.http.get(environment.formBuilder.serverUrl + '/api/v1/form/' + id);
    }

    printTemplate(templateId: string) {
        return this.http.get(`${environment.serverUrl}/taskTemplate/print/${templateId}`, { responseType: 'blob' });
    }

}



// WEBPACK FOOTER //
// ./src/app/forms-preview/forms-preview.service.ts